<div class="number-control" [ngClass]="{ clear: !showButtons }">
  <craft-icon
    *ngIf="showButtons"
    name="components--radio-minus-off-md"
    class="control minus"
    [ngClass]="{ disabled: !canStep(-1) }"
    (click)="minus()"
  >
  </craft-icon>

  <input
    #input
    type="text"
    inputmode="decimal"
    maxlength="16"
    class="input"
    autocomplete="off"
    [disabled]="isDisabled"
    [placeholder]="placeholder"
    (input)="handleInput()"
    (blur)="handleBlur()"
    (keydown.enter)="handleEnter()"
    (keydown.escape)="handleEscape()"
  />

  <craft-icon
    *ngIf="showButtons"
    name="components--radio-add-off-md"
    class="control plus"
    [ngClass]="{ disabled: !canStep(1) }"
    (click)="plus()"
  >
  </craft-icon>
</div>
